module.exports = __webpack_public_path__ + "static/img/11.1932e6a5.png";